// ** React Imports
import { useState, useEffect, SyntheticEvent } from 'react'

import Box from '@mui/material/Box'
import CardHeader from '@mui/material/CardHeader'
import Button from '@mui/material/Button'
import CardContent from '@mui/material/CardContent'
import Grid from '@mui/material/Grid';
import FormControl from '@mui/material/FormControl'
import {
    Divider,
    IconButton,
    Tooltip,
    Fab,
    MenuItem,
    InputLabel,
    Select,
    Table,
    TableHead,
    TableRow,
    TableCell,
    TableBody,
    Typography,
    CircularProgress
} from '@mui/material'
import { useNavigate } from "react-router-dom";
import axios from 'axios'

import Icon from '../../../components/icon';
import apiUrl from '../../../configs/constant';
import MsiDatagrid from '../../../components/custom/MsiDatagridAuto';
import { useToast } from '../../../components/ToastProvider'
import { Controller, useForm } from 'react-hook-form'
import { getPeriode } from '../../../api/helper'
import Swal from 'sweetalert2'

export default function Index() {
    const userData = JSON.parse(localStorage.getItem('user')!)
    const token = userData.token
    const { showToast, hideToast } = useToast();
    const [valPeriode, setValPeriode] = useState<any>(null)
    const [loading, setLoading] = useState<Boolean>(false)

    // ** State
    const [listData, setListData] = useState({
        pendapatan: [],
        hpp: [],
        beban: [],
        lainnya: []
    })
    const [listPeriode, setListPeriode] = useState<any[]>([])

    useEffect(() => {
        const fetchPeriode = async () => {
            const response = await getPeriode(token);
            setListPeriode(response);
        };

        fetchPeriode()
    }, [])

    const navigate = useNavigate();

    const getData = () => {
        if (!valPeriode || valPeriode == "") {
            Swal.fire({
                icon: 'warning',
                title: 'Periode belum dipilih',
                text: 'Silakan pilih periode terlebih dahulu',
                confirmButtonText: 'OK'
            })
            return
        }
        setLoading(true);

        setListData({
            pendapatan: [],
            hpp: [],
            beban: [],
            lainnya: []
        })
        let url = apiUrl.apiUrl + '/acc/laporan-keuangan/list-laba-rugi'

        axios
            .get(url, {
                params: {
                    periode: valPeriode,
                },
                headers: { Authorization: `Bearer ${token}` }
            })
            .then(response => {
                if (response.data.success) {
                    const data = response.data
                    setListData(data)
                } else {
                    showToast(response.data.message, 'error');
                }
            })
            .finally(() => {
                setLoading(false)
            })
    }

    interface FormInputs {
        periode: any
    }

    const defaultValues = {
    }

    const {
        control,
        handleSubmit,
        setValue,
        getValues,
        watch,
        formState: { errors }
    } = useForm<FormInputs>({ defaultValues })

    const formatRupiah = (val) => {
        return new Intl.NumberFormat('id-ID', {
            style: 'currency',
            currency: 'IDR'
        }).format(val || 0)
    }

    const sumTotal = (arr = []) => {
        return arr.reduce((acc, item) => acc + (item.total || 0), 0)
    }

    const hasData =
        listData.pendapatan.length > 0 ||
        listData.hpp.length > 0 ||
        listData.beban.length > 0 ||
        listData.lainnya.length > 0

    const handleLihat = (item) => {
        const tglAwal = '2026-01-01'
        const tglAkhir = '2026-01-01'

        const url = `/acc/buku-besar?tglAwal=${tglAwal}&tglAkhir=${tglAkhir}&akun=${item.akun}`

        window.open(url, '_blank')
    }

    return (
        <Grid container spacing={3} sx={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center' }}>
            <Grid item xs={12}>
                <div className={'content-block dx-card'}>
                    <Box
                        sx={{
                            width: '100%',
                            display: 'flex',
                            flexWrap: 'wrap',
                            alignItems: 'center',
                            justifyContent: 'space-between'
                        }}
                    >
                        <Box sx={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center' }}>
                            <CardHeader title='LABA RUGI' />
                        </Box>
                    </Box>
                    <Divider />
                    <CardContent>
                        <Grid
                            item
                            container
                            sx={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'flex-start' }}
                            spacing={5}
                        >
                            <Grid item xs={4} sm={4}>
                                <FormControl fullWidth>
                                    <InputLabel>Periode</InputLabel>
                                    <Controller
                                        name='periode'
                                        control={control}
                                        rules={{ required: true }}
                                        render={({ field: { value, onChange } }) => (
                                            <Select
                                                label='Periode'
                                                value={value || ''}
                                                onChange={(e) => {
                                                    const newValue = e.target.value
                                                    onChange(newValue)
                                                    setValPeriode(newValue)
                                                }}
                                            >
                                                {listPeriode.map((item: any, index: any) => (
                                                    <MenuItem value={item.id} key={index}>
                                                        {item.periode}
                                                    </MenuItem>
                                                ))}
                                            </Select>
                                        )}
                                    />
                                </FormControl>
                            </Grid>
                            <Grid item xs={2} md={2}>
                                <FormControl fullWidth>
                                    <Button
                                        variant='contained'
                                        sx={{ mt: 1 }}
                                        startIcon={<Icon icon='mdi:magnify' />}
                                        onClick={getData}
                                    >
                                        Lihat Data
                                    </Button>
                                </FormControl>
                            </Grid>
                            <Grid item xs={2} md={2}>
                                <FormControl fullWidth>
                                    <Button
                                        variant='contained'
                                        color='error'
                                        sx={{ mt: 1 }}
                                        startIcon={<Icon icon='mdi:file-pdf-box' />}
                                        onClick={() => {
                                            if (!valPeriode) {
                                                Swal.fire({
                                                    icon: 'warning',
                                                    title: 'Periode belum dipilih',
                                                    text: 'Silakan pilih periode terlebih dahulu'
                                                })
                                                return
                                            }

                                            const url = `https://api.mylittlefairies.online/acc/laporan/pdf/laba-rugi?periode=${valPeriode}`
                                            window.open(url, '_blank')
                                        }}
                                    >
                                        Lihat PDF
                                    </Button>
                                </FormControl>
                            </Grid>
                        </Grid>
                    </CardContent>
                    {loading ? (
                        <Grid container spacing={3} sx={{ mt: 2, mb: 2, px: 3, justifyContent: 'center' }}>
                            <Grid container justifyContent="center" sx={{ mt: 5, mb: 5 }}>
                                <CircularProgress />
                            </Grid>
                        </Grid>
                    ) : hasData ? (
                        <Grid container spacing={3} sx={{ mt: 2, px: 3, justifyContent: 'center' }}>
                            <Grid item xs={12} md={8}>
                                <Box sx={{ p: 3, border: '1px solid #eee', borderRadius: 2 }}>
                                    <h3 style={{ textAlign: 'center' }}>Laporan Laba Rugi</h3>

                                    <Table size="small">
                                        <TableBody>

                                            {/* ===== PENDAPATAN ===== */}
                                            <TableRow>
                                                <TableCell colSpan={3}><b>Pendapatan</b></TableCell>
                                            </TableRow>

                                            {(listData.pendapatan || []).map((item, i) => (
                                                <TableRow key={i}>
                                                    <TableCell sx={{ pl: 2 }}>{item.nama_akun}</TableCell>
                                                    <TableCell align="right">{formatRupiah(item.total)}</TableCell>
                                                    <TableCell align="center">
                                                        <Button size="small" onClick={() => handleLihat(item)}>
                                                            Lihat
                                                        </Button>
                                                    </TableCell>
                                                </TableRow>
                                            ))}

                                            <TableRow>
                                                <TableCell><b>Total Pendapatan</b></TableCell>
                                                <TableCell align="right">
                                                    <b>{formatRupiah(sumTotal(listData.pendapatan))}</b>
                                                </TableCell>
                                                <TableCell />
                                            </TableRow>

                                            {/* ===== HPP ===== */}
                                            <TableRow>
                                                <TableCell colSpan={3}><b>Harga Pokok Penjualan (HPP)</b></TableCell>
                                            </TableRow>

                                            {(listData.hpp || []).map((item, i) => (
                                                <TableRow key={i}>
                                                    <TableCell sx={{ pl: 2 }}>{item.nama_akun}</TableCell>
                                                    <TableCell align="right">{formatRupiah(item.total)}</TableCell>
                                                    <TableCell align="center">
                                                        <Button size="small" onClick={() => handleLihat(item)}>
                                                            Lihat
                                                        </Button>
                                                    </TableCell>
                                                </TableRow>
                                            ))}

                                            <TableRow>
                                                <TableCell><b>Total HPP</b></TableCell>
                                                <TableCell align="right">
                                                    <b>{formatRupiah(sumTotal(listData.hpp))}</b>
                                                </TableCell>
                                                <TableCell />
                                            </TableRow>

                                            {/* ===== LABA KOTOR ===== */}
                                            <TableRow sx={{ bgcolor: '#e3f2fd' }}>
                                                <TableCell><b>Laba Kotor</b></TableCell>
                                                <TableCell align="right">
                                                    <b>
                                                        {formatRupiah(
                                                            sumTotal(listData.pendapatan) -
                                                            sumTotal(listData.hpp)
                                                        )}
                                                    </b>
                                                </TableCell>
                                                <TableCell />
                                            </TableRow>

                                            {/* ===== BEBAN ===== */}
                                            <TableRow>
                                                <TableCell colSpan={3}><b>Beban</b></TableCell>
                                            </TableRow>

                                            {(listData.beban || []).map((item, i) => (
                                                <TableRow key={i}>
                                                    <TableCell sx={{ pl: 2 }}>{item.nama_akun}</TableCell>
                                                    <TableCell align="right">{formatRupiah(item.total)}</TableCell>
                                                    <TableCell align="center">
                                                        <Button size="small" onClick={() => handleLihat(item)}>
                                                            Lihat
                                                        </Button>
                                                    </TableCell>
                                                </TableRow>
                                            ))}

                                            <TableRow>
                                                <TableCell><b>Total Beban</b></TableCell>
                                                <TableCell align="right">
                                                    <b>{formatRupiah(sumTotal(listData.beban))}</b>
                                                </TableCell>
                                                <TableCell />
                                            </TableRow>

                                            {/* ===== LABA OPERASIONAL ===== */}
                                            <TableRow sx={{ bgcolor: '#e8f5e9' }}>
                                                <TableCell><b>Laba Operasional</b></TableCell>
                                                <TableCell align="right">
                                                    <b>
                                                        {formatRupiah(
                                                            (sumTotal(listData.pendapatan) -
                                                                sumTotal(listData.hpp)) -
                                                            sumTotal(listData.beban)
                                                        )}
                                                    </b>
                                                </TableCell>
                                                <TableCell />
                                            </TableRow>

                                            {/* ===== LAINNYA ===== */}
                                            <TableRow>
                                                <TableCell colSpan={3}><b>Pendapatan / Beban Lainnya</b></TableCell>
                                            </TableRow>

                                            {(listData.lainnya || []).map((item, i) => (
                                                <TableRow key={i}>
                                                    <TableCell sx={{ pl: 2 }}>{item.nama_akun}</TableCell>
                                                    <TableCell align="right">{formatRupiah(item.total)}</TableCell>
                                                    <TableCell align="center">
                                                        <Button size="small" onClick={() => handleLihat(item)}>
                                                            Lihat
                                                        </Button>
                                                    </TableCell>
                                                </TableRow>
                                            ))}

                                            <TableRow>
                                                <TableCell><b>Total Lainnya</b></TableCell>
                                                <TableCell align="right">
                                                    <b>{formatRupiah(sumTotal(listData.lainnya))}</b>
                                                </TableCell>
                                                <TableCell />
                                            </TableRow>

                                            {/* ===== LABA BERSIH ===== */}
                                            <TableRow sx={{ bgcolor: '#c8e6c9' }}>
                                                <TableCell><b>Laba Bersih</b></TableCell>
                                                <TableCell align="right">
                                                    <b>
                                                        {formatRupiah(
                                                            (
                                                                (sumTotal(listData.pendapatan) -
                                                                    sumTotal(listData.hpp)) -
                                                                sumTotal(listData.beban)
                                                            ) +
                                                            sumTotal(listData.lainnya)
                                                        )}
                                                    </b>
                                                </TableCell>
                                                <TableCell />
                                            </TableRow>

                                        </TableBody>
                                    </Table>
                                </Box>
                            </Grid>
                        </Grid>
                    ) : (
                        <Grid container spacing={3} sx={{ mt: 2, mb: 2, px: 3, justifyContent: 'center' }}>
                            <Typography align="center" sx={{ mt: 5, mb: 5 }}>
                                Tidak ada data
                            </Typography>
                        </Grid>
                    )}
                </div>
            </Grid>
        </Grid>
    )
}
